import React from 'react';
import * as Yup from 'yup';
import { Paper, withStyles } from '@material-ui/core';
import SKUMappingForm from './SKUMappingForm';
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from 'react-redux';
import * as actions from './store/skuMappingActions';
import History from '../../../History';

const styles = (theme) => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
});

const SKUMappingCreate = (props) => {
    const { permissions, activeCustomer, translations, onCreateSKUMapping, classes } = props;

    const handleSubmit = async (data) => {
        let result = await onCreateSKUMapping({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        ProductType: '',
        Vendor: '',
        Model: '',
        ProductIdentifier: '',
        Storage: '',
        Memory: '',
        CPU: '',
        GPU: '',
        Grading: '',
        Color: '',
        Carrier: '',
        SKU: '',
    };

    const maxLengthValidationText = 'Maximum 255 characters are allowed';
    const maxLengthValidationFn = (val) => (val ? val?.length <= 255 : true);

    let formSettings = {
        Validation: {
            ProductType: Yup.string().required('Required'),
            Vendor: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Model: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            ProductIdentifier: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Storage: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Memory: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            CPU: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            GPU: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Grading: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Color: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Carrier: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            SKU: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
        },
        FormTitle: translations['create_sku_mapping'] || 'Create SKU mapping',
        ButtonSubmit: hasPermission(permissions, 'sku_mapping_create')
            ? {
                  Title: translations['save'] || 'SAVE',
                  Color: 'primary',
              }
            : null,
    };
    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <SKUMappingForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
            />
        </Paper>
    );
};
const mapStateToProps = (state) => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onCreateSKUMapping: (skuMapping) => dispatch(actions.createSKUMapping(skuMapping)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(SKUMappingCreate));
